/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_TurnaroundInputs */

const en_field_turnaround = /** @type {(inputs: Field_TurnaroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est. Turnaround (Days)`)
};

const es_field_turnaround = /** @type {(inputs: Field_TurnaroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo estimado (Días)`)
};

const fr_field_turnaround = /** @type {(inputs: Field_TurnaroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Délai estimé (Jours)`)
};

const de_field_turnaround = /** @type {(inputs: Field_TurnaroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschätzte Bearbeitungszeit (Tage)`)
};

const ja_field_turnaround = /** @type {(inputs: Field_TurnaroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推定納期 (日数)`)
};

const zh_field_turnaround = /** @type {(inputs: Field_TurnaroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预计完成时间 (天)`)
};

const ar_field_turnaround = /** @type {(inputs: Field_TurnaroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوقت المتوقع للإنجاز (بالأيام)`)
};

const id_field_turnaround = /** @type {(inputs: Field_TurnaroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimasi Penyelesaian (Hari)`)
};

const it_field_turnaround = /** @type {(inputs: Field_TurnaroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempi di Consegna Stimati (Giorni)`)
};

const ru_field_turnaround = /** @type {(inputs: Field_TurnaroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примерный срок выполнения (Дней)`)
};

const pt_field_turnaround = /** @type {(inputs: Field_TurnaroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prazo de Entrega Estimado (Dias)`)
};

const ko_field_turnaround = /** @type {(inputs: Field_TurnaroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예상 작업 소요 시간 (일)`)
};

/**
* | output |
* | --- |
* | "Est. Turnaround (Days)" |
*
* @param {Field_TurnaroundInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_turnaround = /** @type {((inputs?: Field_TurnaroundInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_TurnaroundInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_turnaround(inputs)
	if (locale === "es") return es_field_turnaround(inputs)
	if (locale === "fr") return fr_field_turnaround(inputs)
	if (locale === "de") return de_field_turnaround(inputs)
	if (locale === "ja") return ja_field_turnaround(inputs)
	if (locale === "zh") return zh_field_turnaround(inputs)
	if (locale === "ar") return ar_field_turnaround(inputs)
	if (locale === "id") return id_field_turnaround(inputs)
	if (locale === "it") return it_field_turnaround(inputs)
	if (locale === "ru") return ru_field_turnaround(inputs)
	if (locale === "pt") return pt_field_turnaround(inputs)
	return ko_field_turnaround(inputs)
});